import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';

const Carrier = ({ state, onChange, stateError, darkMode, walkthroughId }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            sx={{ margin: '0 !important' }}
            isInvalid={!state?.carrier && stateError?.carrier}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={stackStyling()}>
                <Box width={190}>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                        }}>
                        Carrier
                    </FormLabel>
                </Box>
                <Field
                    component={NameField}
                    width={520}
                    id="carrier"
                    name="carrier"
                    value={state?.carrier}
                    onChange={onChange}
                    walkthroughid={walkthroughId}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Incumbant carrier numbers to port away from"
                        ariaLabel="carrier-tip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
            <FieldError>{stateError?.carrier}</FieldError>
        </FormControl>
    );
};

export default Carrier;
